import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { DesignSnackListContainer } from "@/components/features/snack/snack/list/ui/components";

import { useGetParams } from "./hooks/use-get-params";

export const DesignSnackListPage = () => {
	const { hotelID } = useGetParams();

	return (
		<PageMeta title="スナックの一覧" url={generatePath(PATHS.HOTEL.RESERVATION_PAGE.SNACK.LIST, { hotelID })}>
			<DesignSnackListContainer hotelID={hotelID} />
		</PageMeta>
	);
};

DesignSnackListPage.displayName = "DesignSnackListPage";
